import * as React from 'react';
import { AlertUrgentFilled, ImportantFilled, MentionFilled, PeopleFilled } from '@fluentui/react-icons';
export const getDecorationIcon = (decoration)=>{
    switch(decoration){
        case 'important':
            return /*#__PURE__*/ React.createElement(ImportantFilled, null);
        case 'urgent':
            return /*#__PURE__*/ React.createElement(AlertUrgentFilled, null);
        case 'mention':
            return /*#__PURE__*/ React.createElement(MentionFilled, null);
        case 'mentionEveryone':
            return /*#__PURE__*/ React.createElement(PeopleFilled, null);
        default:
            return null;
    }
};

//# sourceMappingURL=getDecorationIcon.js.map